import { Draft } from '@reduxjs/toolkit';

import { IUserData } from '../../index';

function changePasswordSuccess(draft: Draft<IUserData>) {
  draft.changePassword.config.isLoading = false;
}

export default changePasswordSuccess;
